import { Download } from 'lucide-react';

import type { BulkAction } from '../types';

// Client-side CSV export of the current selection (rows are already in hand).
export const ExportCsvAction: BulkAction = {
  id: 'export-csv',
  isAvailable: () => true,
  Component: ({ ctx }) => (
    <button
      type="button"
      className="btn btn--primary btn--sm"
      onClick={ctx.onExport}
      disabled={ctx.isExporting}
    >
      <Download size={14} />
      {ctx.isExporting ? 'Exporting…' : `Export ${ctx.count} selected to CSV`}
    </button>
  ),
};
